export default "__VITE_ASSET__e9eb98d5__"